import Vue from 'vue'
import { store } from './store';
import { router } from './helpers';
import { config } from './config';

import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

if (config.googleMaps.enabled) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: config.googleMaps.key,
      libraries: config.googleMaps.libraries // This is required if you use the Autocomplete plugin
    },
    installComponents: true
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')